import React, { Component, useState } from 'react'
import Grid from '@mui/material/Grid'
import CircularProgress from '@mui/material/CircularProgress'
import { Paragraph } from '../../../assets/Text'
import Divider from '@mui/material/Divider'
// import { Divider } from '../../../assets/UIElements'
import Avatar from '@mui/material/Avatar'
import { MessengerInput } from '../../../assets/Chat'
import ProfileCard from './ProfileCard'
import SupportiveMessages from './SupportiveMessages'
import UserInteractionHelper from '../../../helpers/UserInteractionHelper'
import AiInteractionHelper from '../../../helpers/AiInteractionHelper'
import AuthenticationHelper from '../../../helpers/AuthenticationHelper'
import GH from '../../../helpers/GeneralHelper'
import UserMatchHelper from '../../../helpers/UserMatchHelper'
import matchConfig from '../../../config/matchConfig'
import * as Icons from '../../../assets/Icons'
import MUIIconButton from '@mui/material/IconButton'
import {Stack, Box} from '@mui/material'
import {IconButton} from '../../../assets/Buttons'

// import GH from '../../../helpers/GeneralHelper'

class Stories extends Component {
    _isMounted = false

    constructor(props)
    {
        super(props)
        this.state = {
            initComplete: false,
        }
    }


    /*
    add parameter connected, hugged, supportMsgTime, supportMsg
    */
    getProcessedInteractionList(recUserList,contactList,userHugsList,supportMsgList){
        //loop through each recUser
        let processedList=[]
        console.log("INPUT LIST")
        console.log(recUserList)
        recUserList.recUser.forEach( (item,index) =>
        {
            let tempObj= item
            //by default, put everything as false first, in case no data for contact list, huglist, supportmsg list exists
            tempObj.hugged =false
            tempObj.connected =false
            tempObj.supportMsgTime = new Date()
            tempObj.supportMsg = ""

            if(userHugsList.hasOwnProperty('data') && userHugsList.data !== null && userHugsList.data.length > 0){
                userHugsList.data.findIndex(x => x.reciever_id ===item.id) === -1? 
                tempObj.hugged =false :  tempObj.hugged =true
            }

            if(contactList.hasOwnProperty('data') && contactList.data !== null  && contactList.data.length > 0 ) {
                contactList.data.findIndex(x => x.reciever_id ===item.id) === -1? 
                tempObj.connected =false :  tempObj.connected =true
            }

            if(supportMsgList.hasOwnProperty('data') && supportMsgList.data !== null && supportMsgList.data.length > 0){
                let supportMsgIndex=supportMsgList.data.findIndex(x => x.reciever_id ===item.id)   
                if(supportMsgIndex !==-1)
                { 
                  tempObj.supportMsgTime = new Date(supportMsgList.data[supportMsgIndex].sent_time)
                  tempObj.supportMsg = supportMsgList.data[supportMsgIndex].message 
                }
                else
                {
                  tempObj.supportMsgTime = new Date()
                  tempObj.supportMsg = ""
                }
            

            }
            processedList[index]=tempObj
            
        })
 
        return processedList

    }

    async componentDidMount()
    {
        this._isMounted = true
        try {
            const userId = AuthenticationHelper.uuid
            let dataList = []
            const source = matchConfig.stories?.source || 'human'
            
            if (userId) {
                let recResp = await UserMatchHelper.getRecProfile(userId, 36) //change here to adjust number of profiles fetched
                
                if (recResp && Array.isArray(recResp.recUser)) {
                    dataList = recResp.recUser
                }
            }

            if (Array.isArray(dataList) && dataList.length > 0) {
            const connected = Array.isArray(this.props.connectedUsers) ? this.props.connectedUsers : [];
            const connectedIds = new Set(connected.map(c => c.reciever_id || c.id));
            dataList = dataList.filter(p => !connectedIds.has(p.id));

            let mapped = dataList.map(p => ({
                id: p.id,
                display_name: p.display_name || p.username || 'User',
                age: p.age || '',
                gender: p.gender || '',
                state_address: p.state_address || '',
                study_field: p.study_field || '',
                problem_category_1: p.problem_category_1 || '',
                problem_category_2: p.problem_category_2 || '',
                problem_category_3: p.problem_category_3 || '',
                living_situation: p.living_situation || p.livingsituation || '',
                hobbies_description: p.hobbies_description || '',
                coping_strategy_1: p.coping_strategy_1 || '',
                coping_strategy_2: p.coping_strategy_2 || '',
                coping_strategy_3: p.coping_strategy_3 || '',
                loss_description: p.loss_description || p.description || p.system_prompt || '',
                description: p.loss_description || p.description || p.system_prompt || '',
                hugged: false,
                connected: false,
                supportMsg: '',
                supportMsgTime: new Date()
            }));

            // Hybrid approach: keep top N ranked matches, randomize the rest
            const rankTopMatches = matchConfig.stories?.rankTopMatches || 0;
            
            if (rankTopMatches > 0 && rankTopMatches < mapped.length) {
                // Keep top N matches ranked (best ML scores first), randomize the rest
                const rankedMatches = mapped.slice(0, rankTopMatches);
                const restMatches = mapped.slice(rankTopMatches);
                
                // Randomize only the rest (Fisher–Yates)
                for (let i = restMatches.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [restMatches[i], restMatches[j]] = [restMatches[j], restMatches[i]];
                }
                
                mapped = [...rankedMatches, ...restMatches];
            } else if (rankTopMatches === 0) {
                // All random (backward compatible - original behavior)
                for (let i = mapped.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [mapped[i], mapped[j]] = [mapped[j], mapped[i]];
                }
            }
            // else: rankTopMatches >= mapped.length, keep all ranked (no randomization)
                
                await this.props.updateMatches(mapped)
                if (this._isMounted) this.setState({ initComplete: true })
                return
            }
            await this.props.updateMatches([])
            if (this._isMounted) this.setState({ initComplete: true })
            return
        } catch (e) {
            console.warn('Stories: failed to load profiles', e)
            await this.props.updateMatches([])
            if (this._isMounted) this.setState({ initComplete: true })
            return
        }
    }

    componentWillUnmount()
    {
        this._isMounted = false
    }

    render()
    {
        let lang = this.props.lang.support
        if(!this.props.hasOwnProperty('matches') || this.props.matches.length <= 0)
        {
            return <Grid item className='my-4'>
                <Paragraph className='fyw-font-dark'>{lang.noStories}</Paragraph>
            </Grid>
        }

        let profiles = []
        if(!this.state.initComplete)
        {
            profiles = this.props.matches.map((match, idx) => (
                <ProfileCard 
                    key={`match-stories-${idx}`}
                    profile={match}
                    className='mb-4'
                    component={<CircularProgress />}
                    lang={this.props.lang.profile}
                    selectedLang={this.props.selectedLang}
                    type={"interactive"}
                    connectComponent={<CircularProgress />}
                />
            ))

        }
        else
        {
            profiles = this.props.matches.map((match, idx) => (
                <ProfileCard 
                    key={`match-stories-${idx}`}
                    profile={match}
                    className='mb-4'
                    component={<MessageChannel 
                        profile={this.props.profile}
                        match={match}
                        initComplete={this.state.initComplete}
                        lang={this.props.lang.support}
                        selectedLang={this.props.selectedLang}
                    />}
                    type={"interactive"}
                    connectComponent={<InteractionPanel 
                        match={match} 
                        selectedLang={this.props.selectedLang} 
                        name={match?.display_name || ""} 
                        lang={lang}
                        updateConnectedUsers={this.props.updateConnectedUsers}
                        loopConnectedUsers={this.props.loopConnectedUsers}
                    />}
                    lang={this.props.lang.profile}
                />
            ))
        }

        // console.log(this.props)
        return (<Box item xs sx={{ width: '100%', maxWidth: {
                xs: 'xs',
                sm: 'md',
                md: 'md',
                lg: 'md',
                xl: 'md'
            }, 
            px: 2,
            mx: 'auto',
            pb: 4
        }}>
        <Grid container direction={"column"}>
            <Stack direction="column" spacing={3}>
                <Paragraph variant="body2">{lang.storyIntro}</Paragraph>
                {profiles}
            </Stack>
            <Grid item sx={{
                mt: 2
            }}>
                <Paragraph variant="body2" align={"center"}>{lang.endOfPage}</Paragraph>
            </Grid>
        </Grid>
        </Box>)
    }
}

// manage the interaction panel to the level of component to enhance the performance of the website
class MessageChannel extends Component {

    constructor(props)
    {
        super(props)

        this.state = {
            hugged: this.props.match.hugged,
            connected: this.props.match.connected,
            supportMsg: this.props.match.supportMsg,
            supportMsgTime: new Date(this.props.supportMsgTime),
            loaded: false
        }
        
        this.updateHug = this.updateHug.bind(this)
        this.updateConnect = this.updateConnect.bind(this)
        this.updateSupportMsg = this.updateSupportMsg.bind(this)
    }

    componentDidMount()
    {
        // console.log(`check hug ${this.props.match.hugged}`)
        this.setState({
            loaded: true
        })
    }

    async updateHug()
    {
        try
        {
            const matchId = this.props.match.id
            if(!this.state.hugged)
            {
                const addHugresult = await AiInteractionHelper.addHug(AuthenticationHelper.uuid, matchId)
                if(addHugresult.hasOwnProperty('status') && addHugresult.status === 'success')
                {
                    this.setState({
                        hugged: true
                    })
                    return true
                }
                return false
            }

            const removeHugresult = await AiInteractionHelper.removeHug(AuthenticationHelper.uuid, matchId)
            if(removeHugresult.hasOwnProperty('status') && removeHugresult.status === 'success')
            {
                this.setState({
                    hugged: false
                })
                return true
            }
            return false

        }
        catch(e)
        {
            console.log(e)
            return false
        }
    }

    async updateConnect()
    {
        try
        {
            const matchId = this.props.match.id

            if(!this.state.connected)
            {
                const addContactResult = await AiInteractionHelper.addContact(AuthenticationHelper.uuid, matchId)
                if(addContactResult.hasOwnProperty('status') && addContactResult.status === 'success')
                {
                    this.setState({
                        connected: true
                    })
                    return true
                }
                return false
            }
            
            const removeContactResult = await AiInteractionHelper.removeContact(AuthenticationHelper.uuid, matchId)
            if(removeContactResult.hasOwnProperty('status') && removeContactResult.status === 'success')
            {
                this.setState({
                    connected: false
                })
                return true
            }
            return false

        }
        catch(e)
        {
            console.log(e)
            return false
        }
    }

    async updateSupportMsg(comment)
    {
        try
        {
            const matchId = this.props.match.id

            if(comment !== '')
            {
                const addSupportMsgResult = await AiInteractionHelper.addSupportMsg(AuthenticationHelper.uuid, matchId, comment)
                
                if(addSupportMsgResult.hasOwnProperty('status') && addSupportMsgResult.status === 'success')
                {
                    this.setState({
                        supportMsg: comment,
                        supportMsgTime: new Date()
                    })
                }
                return
            }

            const removeSupportMsgResult = await AiInteractionHelper.removeSupportMsg(AuthenticationHelper.uuid, matchId)
            
            if(removeSupportMsgResult.hasOwnProperty('status') && removeSupportMsgResult.status === 'success')
            {
                this.setState({
                    supportMsg: '',
                    supportMsgTime: new Date()
                })
            }
            return

        }
        catch(e)
        {
            console.log(e)
        }
    }

    render()
    {
        //console.log(this.props.selectedLang)
        // console.log("rendered")
        // console.log(this.state.hugged)
        return (<>
        {/*<InteractionPanel 
            name={this.props.match.display_name}
            sendHug={this.updateHug}
            connect={this.updateConnect}
            hugged={this.state.hugged || false}
            connected={this.state.connected || false}
            lang={this.props.lang}
            selectedLang={this.props.selectedLang}
        />*/}
        {/*<Grid item xs={10} className='mx-auto'><Divider /></Grid>*/}
        {!this.state.loaded && <CircularProgress />}
        {this.state.loaded && 
        <LeaveComment 
            name={this.props.match.display_name}
            user={this.props.profile.display_name}
            supportMsg={this.props.match.supportMsg}
            supportMsgTime={this.props.match.supportMsgTime || new Date()}
            sendSupportMsg={this.updateSupportMsg}
            lang={this.props.lang}
            selectedLang={this.props.selectedLang}
        />}

        </>)
    }
}

const InteractionPanel = props => {
    // console.log("interaction props", props)
    // console.log("initial interaction, hugged for ", props.name, props?.match?.hugged)
    const [hugged, updateHug] = useState(props?.match?.hugged)
    const [connected, updateConnect] = useState(props?.match?.connected)
    // if(!props?.loaded) return null

    //decide on the hug message order 
    let hugMessageOrder=`${props.lang.hug} ${props.name}`
    let huggedMessageOrder=`${props.lang.hugged} ${props.name}`
    let connectMessageOrder= `${props.lang.connectedTo} ${props.name}`
    let connectedMessageOrder=`${props.lang.connectTo} ${props.name}` 
    // console.log("user name ", props)
    if(props.selectedLang==='ja'){
        hugMessageOrder=`${props.name} ${props.lang.hug}`
        huggedMessageOrder=`${props.name} ${props.lang.hugged}`
        connectMessageOrder= `${props.name} ${props.lang.connectedTo}`
        connectedMessageOrder=`${props.name} ${props.lang.connectTo}` 
    }
    else{
        hugMessageOrder=`${props.lang.hug} ${props.name}`
        huggedMessageOrder=`${props.lang.hugged} ${props.name}`
        connectMessageOrder= `${props.lang.connectedTo} ${props.name}`
        connectedMessageOrder=`${props.lang.connectTo} ${props.name}` 
    }

    const sendHug = async () =>
    {
        try
        {
            const matchId = props.match.id
            if(!hugged)
            {
                const addHugresult = await AiInteractionHelper.addHug(AuthenticationHelper.uuid, matchId)
                if(addHugresult.hasOwnProperty('status') && addHugresult.status === 'success')
                {
                    updateHug(true)
                    return true
                }
                return false
            }

            const removeHugresult = await AiInteractionHelper.removeHug(AuthenticationHelper.uuid, matchId)
            if(removeHugresult.hasOwnProperty('status') && removeHugresult.status === 'success')
            {
                updateHug(false)
                return true
            }
            return false

        }
        catch(e)
        {
            console.log(e)
            return false
        }
    }

    const sendConnectRequest = async () => 
    {
        try
        {
            const matchId = props.match.id

            if(!connected)
            {
                // For AI profiles, call AI interaction endpoint (no Rocket.Chat room)
                const addContactResult = await AiInteractionHelper.addContact(AuthenticationHelper.uuid, matchId)
                if(addContactResult && addContactResult.status === 'success'){
                    updateConnect(true)
                    // Optimistically push into connected users so it appears in Connect tab immediately
                    try {
                        const newContact = {
                            contact_id: addContactResult.addedID || `${AuthenticationHelper.uuid}-${matchId}`,
                            sender_id: AuthenticationHelper.uuid,
                            reciever_id: matchId,
                            id: matchId,
                            reciever_display_name: props?.match?.display_name || 'AI'
                        }
                        const current = Array.isArray(props.connectedUsers) ? props.connectedUsers : []
                        const exists = current.find(c => c.contact_id === newContact.contact_id)
                        const merged = exists ? current : current.concat([newContact])
                        if (props.updateConnectedUsers) await props.updateConnectedUsers(merged)
                        if (props.loopConnectedUsers) await props.loopConnectedUsers(merged)
                    } catch(e){ console.warn('Failed to optimistically update connected users for AI connect', e) }
                    return true
                }
                return false
            }
            
            const removeContactResult = await AiInteractionHelper.removeContact(AuthenticationHelper.uuid, matchId)
            if(removeContactResult.hasOwnProperty('status') && removeContactResult.status === 'success')
            {
                updateConnect(false)
                return true
            }
            return false

        }
        catch(e)
        {
            console.log(e)
            return false
        }
    }

    return (<Stack direction={{
        md: 'column',
        sm: 'column',
        xs: 'row'
    }} spacing={1}>
        <Box>
            <IconButton
                sx={{
                    display:{
                        xs: 'none',
                        sm: 'flex',
                        md: 'flex'
                    }
                }}
                color={hugged ? 'primary':'lightBtn'}
                onClick={async (e) => {
                    e.preventDefault()
                    updateHug(!hugged)
                    const result = await sendHug()
                    console.log("hug result", result)
                    if(!result)
                    {
                        updateHug(!hugged)
                    }
                }}
                title={hugged ? props.name !== null || props.name !== '' ? huggedMessageOrder : props.lang.hugSent
                    : props.name !== null || props.name !== '' ? hugMessageOrder : props.lang.sendHug} 
                icon={hugged ? <Icons.HuggedCountIcon style={{ width: '48px' }} />:<Icons.HugsCountIcon style={{ width: '48px' }} />} />
            <MUIIconButton 
                sx={{
                    display:{
                        xs: 'flex',
                        sm: 'none',
                        md: 'none',
                        lg: 'none',
                        xl: 'none'
                    },
                    borderRadius: 4,
                    bgcolor: hugged ? 'primary.main':'lightBtn.main',
                    boxShadow: 2
                }}
                onClick={async (e) => {
                    e.preventDefault()
                    updateHug(!hugged)
                    const result = await sendHug()
                    console.log("hug result", result)
                    if(!result)
                    {
                        updateHug(!hugged)
                    }
                }}
            >
                {hugged ? <Icons.HuggedCountIcon style={{ width: '48px' }} />:<Icons.HugsCountIcon style={{ width: '48px' }} />}
            </MUIIconButton>
        </Box>
        {/*<div className='match-interaction-btn cursor-pointer p-2' tabIndex={0} role="button" onClick={async (e) => {
            e.preventDefault()
            updateHug(!hugged)
            const result = await props.sendHug()
            if(!result)
            {
                updateHug(!hugged)
            }
        }}>

            <Paragraph className='text-left'>
                <GetImg 
                    className={['match-icon-sm']}
                    onClick={null}
                    imageUrl={hugged ? 'match-hug-clicked.svg' : 'match-hug.svg'} // "name-of-the-img.jpg"
                    alt={'hug'}
                />
                {hugged ? <span className='ml-2'>{props.name !== null || props.name !== '' ? huggedMessageOrder : props.lang.hugSent}</span>
                :<span className='ml-2'>{props.name !== null || props.name !== '' ? hugMessageOrder : props.lang.sendHug}</span>}

            </Paragraph>
        </div>*/}
        <Box>
        <IconButton 
            sx={{
                display:{
                    xs: 'none',
                    sm: 'flex',
                    md: 'flex'
                }
            }}
            onClick={async (e) => {
                // console.log('test')
                e.preventDefault()
                updateConnect(!connected)
                const result = await sendConnectRequest()
                if(!result)
                {
                    updateConnect(!connected)
                }
            }}
            color={connected ? 'primary':'lightBtn'}
            title={connected ? props.name !== null || props.name !== '' ? connectMessageOrder : props.lang.connected
                : props.name !== null || props.name !== '' ? connectedMessageOrder: props.lang.connect} 
                icon={connected ? <Icons.ConnectedIcon style={{ width: '48px' }} />:<Icons.SupportMsgIcon1 style={{ width: '48px' }} />} />
            <MUIIconButton 
                sx={{
                    display:{
                        xs: 'flex',
                        sm: 'none',
                        md: 'none',
                        lg: 'none',
                        xl: 'none'
                    },
                    borderRadius: 4,
                    bgcolor: connected ? 'primary.main':'lightBtn.main',
                    boxShadow: 2
                }}
                onClick={async (e) => {
                    // console.log('test')
                    e.preventDefault()
                    updateConnect(!connected)
                    const result = await sendConnectRequest()
                    if(!result)
                    {
                        updateConnect(!connected)
                    }
                }}
            >
                {connected ? <Icons.ConnectedIcon style={{ width: '48px' }} />:<Icons.SupportMsgIcon1 style={{ width: '48px' }} />}
            </MUIIconButton>
        </Box>
        {/*<div className='match-interaction-btn cursor-pointer text-center p-2' tabIndex={0} role="button" onClick={async (e) => {
            // console.log('test')
            e.preventDefault()
            updateConnect(!connected)
            const result = await props.connect()
            if(!result)
            {
                updateConnect(!connected)
            }
        }}>

            <Paragraph className='text-right'>
                <GetImg 
                    onClick={null}
                    className={['match-icon-sm', 'cursor-pointer']}
                    imageUrl={connected ? 'match-confirm-connect-clicked.svg':'match-confirm-connect.svg'} // "name-of-the-img.jpg"
                    alt={'confirm connect'}
                />

                {connected ? <span className='ml-2'>{props.name !== null || props.name !== '' ? connectMessageOrder : props.lang.connected}</span>
                :<span className='ml-2'>{props.name !== null || props.name !== '' ? connectedMessageOrder: props.lang.connect}</span>}
                        
            </Paragraph>
        </div>*/}
    </Stack>)
}

const LeaveComment = props => {
    // console.log(props)
    const initMsg = props.supportMsg !== '' ? props.supportMsg : ''
    const [comment, updateComment] = useState(initMsg)
    const [, updateCommentError] = useState('')
    const [msgSent, updateMsgSent] = useState(initMsg !== '')

    const sendMessage = async () => {
        props.sendSupportMsg(comment)
        updateMsgSent(true)
        // const result = await props.login(GH.removeWhiteSpace(email), GH.removeWhiteSpace(password))
        // if(!result) return updateLoginError(props.lang.loginError)
    }

    // removed unused handleSubmit


    if(!msgSent)
    {
        return (<React.Fragment>
            <Divider />
    
            <Grid item>
    
                <Grid container direction={'row'} justify={"center"} align={"center"} sx={{
                    py: {
                        xs: 2, sm: 2, md: 2
                    },
                    px: {
                        xs: 1,
                        sm: 2
                    }
                }}>
                    <Grid item xs={1} sm={1} md={1}
                        sx={{
                            display:{
                                xs: 'none',
                                sm: 'block'
                            }
                        }}
                    >
                    <Avatar sx={{
                        width: {
                            md: '64px',
                            sm: '64px',
                            xs: '36px'
                        },
                        height: {
                            md: '64px',
                            sm: '64px',
                            xs: '36px'
                        },
                        m: 'auto',
                        bgcolor: 'primary.main'
                    }}>{props.user.length > 1 ? `${props.user[0].toUpperCase()}${props.user[1].toUpperCase()}`:`${props.user[0].toUpperCase()}`}</Avatar>
                    </Grid>
                    <Grid item xs sm md sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        px: 2
                    }}>
                        <form
                            style={{
                                width: '100%'
                            }}
                            onSubmit={(e) => {
                                e.preventDefault()
                                props.sendSupportMsg(comment)
                                updateMsgSent(true)
                            }}
                        >
                        <MessengerInput
                            // placeholder={lang.leaveMessage}
                            // onChange={e => updateSupportMsg(e.target.value)}
                            value={comment}

                            // ref={password => this._password = password}
                            type={"text"}
                            label={props.name !== null ? `${props.lang.leaveMessageTo} (${props.name})`: props.lang.leaveMessage}
                            // ariaLabel='Supportive message'
                            placeholder={props.name !== null ? `${props.lang.supportMessageFor} (${props.name})`: props.lang.supportMessage}
                            // icon='envelope'
                            // withAdornment
                            // endAdornmentIcon={'paper-plane'}
                            // endAdornmentLabel='send'
                            // handleEndAdornmentClick={() => {
                            //     props.sendSupportMsg(comment)
                            //     updateMsgSent(true)
                            // }} 
                            // error={commentError}
                            // helperText={`${comment.length}/250 ${props.lang.words}`}
                            onChange={e => {
                                // console.log(e.target.value.length)
                                if(e.target.value.length > 250)
                                {
                                    updateCommentError(`${props.lang.exceeds} ${comment.length}/250 ${props.lang.words}`)
                                    updateComment(e.target.value)
                                    return
                                }
                                updateCommentError('')
                                updateComment(e.target.value)
                            }}
                        />
                        </form>
                    </Grid>
                    <Box item
                        sx={{
                            width: 1,
                            maxWidth: {
                                xs: '36px',
                                sm: '64px',
                                md: '64px'
                            },
                            my: 'auto'
                        }}
                    >
                        <MUIIconButton color="primary" aria-label="send the supportive message"
                            onClick={() => {
                                props.sendSupportMsg(comment)
                                updateMsgSent(true)
                            }}
                            sx={{                             
                                // width: 1,
                                p: 0,
                                width: {
                                    xs: '36px',
                                    sm: '64px',
                                    md: '64px'
                                },
                                borderRadius: 2,
                                bgcolor: 'background.default',
                                boxShadow: 2
                            }}
                        >
                            <Icons.SendIcon style={{ width: '100%' }} />
                        </MUIIconButton>
                    </Box>
                </Grid>
    
            </Grid>
        </React.Fragment>)
        // return (<>
        //     <Grid item xs={10} className='d-flex mx-auto my-3'>
    
        //     <Grid item xs={2}>
        //         <div className='match-avatar-sm mx-auto'>
        //             <Text className='p-0 m-0'>{props.user.length > 1 ? `${props.user[0].toUpperCase()}${props.user[1].toUpperCase()}`:`${props.user[0].toUpperCase()}`}</Text>
        //         </div>
        //     </Grid>
    
        //     {/*<Grid item xs={10} className='supportive-message-bubble p-3'>
        //         <Text className='p-0 m-0'>{props.message}</Text>
        //     </Grid>*/}

    
        //     <Grid item xs={10}  onKeyPress={handleSubmit} >
        //         <TextInput 
        //             // ref={password => this._password = password}
        //             type={"text"}
        //             label={props.name !== null ? `${props.lang.leaveMessageTo} (${props.name})`: props.lang.leaveMessage}
        //             ariaLabel='Supportive message'
        //             placeholder={props.name !== null ? `${props.lang.supportMessageFor} (${props.name})`: props.lang.supportMessage}
        //             // icon='envelope'
        //             withAdornment
        //             endAdornmentIcon={'paper-plane'}
        //             endAdornmentLabel='send'
        //             handleEndAdornmentClick={() => {
        //                 props.sendSupportMsg(comment)
        //                 updateMsgSent(true)
        //             }} 
        //             error={commentError}
        //             helperText={`${comment.length}/250 ${props.lang.words}`}
        //             onChange={e => {
        //               // console.log(e.target.value.length)
        //               if(e.target.value.length > 250)
        //               {
        //                 updateCommentError(`${props.lang.exceeds} ${comment.length}/250 ${props.lang.words}`)
        //                 updateComment(e.target.value)
        //                 return
        //               }
        //               updateCommentError('')
        //               updateComment(e.target.value)
        //             }}
        //         />
        //     </Grid>
    
        //     </Grid>
            
        // </>)
    }
    return (<Grid item xs={12}>
        <SupportiveMessages 
        display_name={props.user} 
        message={comment} 
        time={props.supportMsgTime} 
        enableDelete 
        handleDelete={() => {
            props.sendSupportMsg('')
            updateMsgSent(false)
        }} />
    </Grid>)
}

export default Stories